import { registerCrudStore } from '@/libs/core/+state/register-crud-store';
import { AuditWorkplaceModel } from '@/libs/Api';
import { AuditWorkplacesDataService } from '@/libs/audit-workplaces/audit-workplaces-data-service';
import { BusinessModule } from '@/libs/core/models/business-module';

export const auditWorkplacesStore = registerCrudStore<AuditWorkplaceModel, AuditWorkplaceModel>(
    BusinessModule.AuditWorkplace,
    new AuditWorkplacesDataService()
);
